<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
  font-family: PingFang SC,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",Helvetica Neue,Helvetica,Hiragino Sans GB,Arial,sans-serif!important
}
#app {
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
}
/*滚动条样式*/
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(160,160,160,0.6);
  background: rgba(0,0,0,0.5);
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(160,160,160,0.6);
  border-radius: 0;
  background: rgba(0,0,0,0.0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue